import {Property} from 'springroll';

export const globals = {
    IS_CANVAS: false,
    LOW_PERFORMANCE: new Property<boolean>(false),
    SMALL_SCREEN: false
};

// By default, treat Kindles as low performance - they seem to have the most performance issues.
const onKindle = /Kindle|Silk|KFAPW|KFARWI|KFASWI|KFFOWI|KFJW|KFMEWI|KFOT|KFSAW|KFSOWI|KFTBW|KFTHW|KFTT|WFFOWI/i.test(navigator.userAgent);
if (onKindle)
{
    globals.LOW_PERFORMANCE.value = true;
}
